import { DotLegalLink, DotLegalTextField, DotLegalTooltip } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { Box } from "@mui/material";
import OpenInNewIcon from "@mui/icons-material/OpenInNew";
import { useTextFieldWithLinkStyles } from "./TextFieldWithLink.styles";

export interface ITextFieldWithLink {
    link?: string;
    onLinkChange: (value: string) => void;
    disabled?: boolean;
    /** Names what the link points at. Falls back to a plain "Link" for callers that have nothing to name. */
    label?: string;
    placeholder?: string;
}

function TextFieldWithLink(props: ITextFieldWithLink) {
    const { translateString } = useTranslation();
    const styles = useTextFieldWithLinkStyles();

    // The field takes whatever the user types, so a bare domain has to be qualified before it can be navigated to.
    const href = props.link?.startsWith("http") ? props.link : `https://${props.link}`;

    return (
        <DotLegalTextField
            disabled={props.disabled}
            label={props.label ?? translateString("link")}
            placeholder={props.placeholder}
            value={props.link ?? ""}
            debounce
            onChange={(value) => props.onLinkChange(value)}
            endAdorment={
                props.link ? (
                    <DotLegalTooltip text={translateString("openLink")}>
                        <Box sx={styles.inlineLink}>
                            <DotLegalLink to={href}>
                                <OpenInNewIcon />
                            </DotLegalLink>
                        </Box>
                    </DotLegalTooltip>
                ) : undefined
            }
        />
    );
}

export default TextFieldWithLink;
